import React, { memo } from "react";
// import { Marker } from 'react-google-maps';
import { MarkerF } from "@react-google-maps/api";


const SpotMarker = ({ lat, lng }) => {
  return (
    <MarkerF
      position={{
        lat: Number(parseFloat(lat)),
        lng: Number(parseFloat(lng))
      }}
    >
    </MarkerF>
  );
};


export default memo(SpotMarker);